import 'css-chunksrc/feature/check/CheckDetailModal.module.scss';export default {
  "tabs": "CheckDetailModal_tabs",
  "check_label_container": "CheckDetailModal_check_label_container",
  "check_label": "CheckDetailModal_check_label"
};